<template>
    <div v-if="state">
        <div v-if="$resize && $root.isSmUp" class="py-6">
            <div class="container flex flex-wrap justify-center">
                <button
                    v-for="item in mergeCategories"
                    :key="item.value"
                    class="my-2 btn-small"
                    :class="{ 'btn-small-active': item.isRefined }"
                    @click="state.refine(item.value)"
                >
                    <span class="btn-shape-left"></span>
                    {{ item.label }}
                    <span class="btn-shape-right"></span>
                </button>
            </div>
        </div>

        <!-- Mobile -->
        <div
            v-else
            class="ais-search-mobile-categories transition-transform duration-200 transform translate-x-full bg-white w-full absolute z-10 px-6 py-12"
        >
            <h2 class="h6 mb-8 px-4 tracking-wide">Categories</h2>

            <div class="bg-white pb-12">
                <div
                    v-for="(item, index) in mergeCategories"
                    :key="item.value"
                    class="block px-4 py-2 border-b border-grey-200 uppercase text-sm tracking-wide"
                >
                    <div v-if="item.children && item.children.length">
                        <button
                            class="flex flex items-center justify-between w-full focus:outline-none"
                            @click="
                                toggleSubCategories(index);
                                state.refine(item.value);
                            "
                        >
                            <span class="text-black uppercase">{{ item.label }}</span>
                            <div class="mr-1">
                                <!-- prettier-ignore -->
                                <svg class="stroke-current" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.06897 1.06897L4.93103 4.93103"  stroke-linecap="square"/><path d="M5.06897 4.93103L8.93103 1.06897"  stroke-linecap="square"/></svg>
                            </div>
                        </button>
                    </div>
                    <div
                        v-else
                        class="flex flex items-center justify-between w-full"
                        @click="
                            state.refine(item.value);
                            filterActive = false;
                            closeCategories();
                            closeSubCategories();
                        "
                    >
                        <span class="text-moss">{{ item.label }}</span>
                        <div
                            :key="item.value"
                            class="border rounded-full w-4 h-4 flex justify-center items-center"
                            :class="{
                                'border-ochre-500': item.isRefined,
                                'border-grey-300': !item.isRefined
                            }"
                        >
                            <div
                                :key="item.value"
                                class="w-2 h-2 bg-yellow-500 rounded-full"
                                :class="{ block: item.isRefined, hidden: !item.isRefined }"
                            ></div>
                        </div>
                    </div>

                    <div
                        v-show="currentSubcategory === index"
                        v-if="item.children && item.children.length"
                        class="text-sm border-t border-grey-200 mt-2 -mx-4"
                    >
                        <a
                            :key="item.value"
                            class="block py-2 last:pb-0 pl-6 pr-4 border-b border-grey-200 last:border-b-0 text-sm"
                            @click="
                                state.refine(item.value);
                                closeCategories();
                            "
                        >
                            <div class="flex flex items-center justify-between w-full">
                                <span
                                    class="block whitespace-no-wrap normal-case font-sans font-normal text-moss"
                                >
                                    All
                                </span>
                                <div
                                    v-if="
                                        currentlyRefined &&
                                        currentlyRefined.children &&
                                        currentlyRefined.children.length
                                    "
                                    class="border rounded-full w-4 h-4 flex justify-center items-center"
                                ></div>
                                <div
                                    v-else
                                    class="border border-ochre-500 rounded-full w-4 h-4 flex justify-center items-center"
                                >
                                    <div class="w-2 h-2 bg-yellow-500 rounded-full"></div>
                                </div>
                            </div>
                        </a>
                        <a
                            v-for="subitem in getSubItems(state.items)"
                            :key="subitem.value"
                            class="block py-2 last:pb-0 pl-6 pr-4 border-b border-grey-200 last:border-b-0 text-sm"
                            @click="
                                state.refine(subitem.value);
                                closeCategories();
                            "
                        >
                            <div class="flex flex items-center justify-between w-full">
                                <span
                                    class="block whitespace-no-wrap normal-case font-sans font-normal text-moss"
                                    :class="[subitem.isRefined ? 'font-medium' : '']"
                                >
                                    {{ subitem.label }}
                                </span>
                                <div
                                    :key="subitem.value"
                                    class="border rounded-full w-4 h-4 flex justify-center items-center"
                                    :class="{ 'border-ochre-500': subitem.isRefined }"
                                >
                                    <div
                                        :key="subitem.value"
                                        class="w-2 h-2 bg-yellow-500 rounded-full"
                                        :class="{
                                            block: subitem.isRefined,
                                            hidden: !subitem.isRefined
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <h2 class="h6 mb-8 px-4 tracking-wide">Locations</h2>

            <div class="bg-white pb-12">
                <Locations />
            </div>
        </div>
        <!-- End Mobile -->
        <div class="container hidden lg:block">
            <div
                v-if="
                    currentlyRefined &&
                    currentlyRefined.children &&
                    currentlyRefined.children.length
                "
                class="subitem-wrapper flex flex-wrap justify-center text-sm"
            >
                <a
                    v-for="subitem in getSubItems(state.items)"
                    :key="subitem.value"
                    class="p-4 cursor-pointer"
                    @click="state.refine(subitem.value)"
                >
                    <span
                        class="inline-block whitespace-no-wrap"
                        :class="[subitem.isRefined ? 'font-medium' : '']"
                    >
                        {{ subitem.label }}
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectHierarchicalMenu } from 'instantsearch.js/es/connectors';
import Locations from '@/components/Locations.vue';

export default {
    components: {
        Locations
    },

    mixins: [createWidgetMixin({ connector: connectHierarchicalMenu })],

    data() {
        return {
            filterActive: false,
            showSubCategories: false,
            currentSubcategory: -10
        };
    },

    computed: {
        widgetParams() {
            return {
                attributes: ['roam_products_categories.lvl0', 'roam_products_categories.lvl1']
            };
        },

        mergeCategories() {
            const noneRefined = !this.state.items.find((item) => item.isRefined);

            const result = this.$root.categories.map((cat) => {
                const match = this.state.items.find((item) => item.label === cat.label);
                let isRefined = match ? match.isRefined : false;

                if (cat.label === 'All') isRefined = noneRefined;

                return {
                    ...cat,
                    isRefined
                };
            });

            return result;
        },

        currentlyRefined() {
            return this.mergeCategories.find((cat) => cat.isRefined);
        }
    },

    methods: {
        getSubItems(items) {
            const refined = items.find((item) => item.isRefined);
            return refined ? refined.data : null;
        },
        closeCategories() {
            document.querySelector('html').classList.remove('ais-Search-categories-active');
        },
        toggleSubCategories(id) {
            if (id === this.currentSubcategory) {
                this.currentSubcategory = -10;
            } else {
                this.currentSubcategory = id;
            }
        },
        closeSubCategories() {
            this.currentSubcategory = -10;
        }
    }
};
</script>
